import React, { forwardRef } from 'react';
import { CalendarIcon, Input } from '../index';

export interface ICustomInputProps {
	widthClasses?: string;
	value: string;
	placeholder: string;
	hasError?: boolean;
	helperText?: string;
	mandatory?: boolean;
	disabled?: boolean;
	onClick: () => void;
	onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

// eslint-disable-next-line react/display-name
export const CustomInput = forwardRef<HTMLInputElement, ICustomInputProps>((props: ICustomInputProps, ref) => {
	return (
		<Input
			ref={ref}
			readonly
			mandatory={props.mandatory}
			widthClasses={props.widthClasses}
			data-cy="calendar-input"
			icon={<CalendarIcon />}
			placeholder={props.placeholder}
			value={props.value}
			hasError={props.hasError}
			helperText={props.helperText}
			className={props.disabled ? 'cursor-not-allowed' : 'caret-transparent cursor-pointer'}
			disabled={Boolean(props.disabled)}
			onClick={() => {
				props.onClick();
			}}
			onKeyDown={props.onKeyDown}
		/>
	);
});
